import React from 'react';
import 'whatwg-fetch';
import { showEntity } from 'src/utils/entityApi';
import withAuth from 'src/hoc/withAuth';

const apiReasonLoose = '/api/stepCommercial/getReasonsOfLoose/';

const oriState = {
  dataReasonLoose: undefined,
  reasonLooseID: -1,
  comment: undefined,
};

class ModalDealLost extends React.Component {
  constructor(props) {
    super(props);
    this.state = oriState;

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.checkFormValid = this.checkFormValid.bind(this);
    this.close = this.close.bind(this);
    this.reset = this.reset.bind(this);
    this.findReasons = this.findReasons.bind(this);
  }

  reset() {
    this.state = oriState;
    this.setState(oriState);
    this.componentDidMount();
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  componentDidMount() {
    this.findReasons();
  }

  findReasons() {
    let queryURL = apiReasonLoose;
    let graphQL = '{ reasonsOfLoose{ id, wording} }';
    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (data['data']['reasonsOfLoose']) {
            this.setState({
              dataReasonLoose: data['data']['reasonsOfLoose'],
            });
          }
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch reason of loose');
        }.bind(this)
      );
  }

  checkFormValid() {
    return this.props.myDeal.isLost || (this.state.reasonLooseID && this.state.reasonLooseID !== -1);
  }

  render() {
    if (this.props.isOpen === false) return null;

    const { dataReasonLoose } = this.state;

    return (
      <div className='modal myModal'>
        <div className='modal-dialog modal-md'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h4 className='modal-title'>{this.props.myDeal.isLost ? 'Réouverture affaire' : 'Affaire Perdue'}</h4>
              <button onClick={this.close} type='button' className='close' data-dismiss='modal' aria-label='Close'>
                <span aria-hidden='true'>&times;</span>
              </button>
            </div>
            <div className='modal-body'>
              {this.props.myDeal.isLost ? (
                <p>{'Vous allez réouvrir l\'affaire "' + this.props.myDeal.name + '"'}</p>
              ) : (
                <p>{'Vous allez passer l\'affaire "' + this.props.myDeal.name + '" en perdu.'}</p>
              )}
            </div>
            <form>
              <div className='modal-body'>
                {!this.props.myDeal.isLost && (
                  <div>
                    <div className='form-group'>
                      <label>Raison de perte</label>
                      <select
                        name='reasonLooseID'
                        value={this.state.reasonLooseID}
                        onChange={this.handleInputChange}
                        className='form-control'
                      >
                        <option value={-1}>Sélectionner raison de perte</option>
                        {dataReasonLoose ? (
                          dataReasonLoose.map((data) => <option value={data.id}>{data.wording}</option>)
                        ) : (
                          <span>Chargement...</span>
                        )}
                      </select>
                    </div>
                    <div className='form-group'>
                      <label>Commentaire</label>
                      <textarea
                        name='comment'
                        value={this.state.comment}
                        onChange={this.handleInputChange}
                        type='text'
                        className='form-control'
                        placeholder='Ajouter commentaire (facultatif)'
                      />
                    </div>
                  </div>
                )}
              </div>
              <div className='modal-actions'>
                <button onClick={this.close} type='button' className='btn-link modal-action' data-dismiss='modal'>
                  Annuler
                </button>
                <button
                  onClick={this.handleSubmit}
                  type='button'
                  className='btn-link modal-action'
                  data-dismiss='modal'
                >
                  <strong>Valider</strong>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }

  handleSubmit() {
    if (this.props.onPostResult) {
      if (this.checkFormValid()) {
        let comment = this.state.comment ? '"' + this.state.comment + '"' : null;
        let graphQL =
          'mutation{ deal(id:' +
          this.props.myDeal.id +
          ', lost:' +
          !this.props.myDeal.isLost +
          ', comment:' +
          comment +
          ', reasonOfLoose:{id:' +
          this.state.reasonLooseID +
          '}){ id, name, lost, reasonOfLoose{ id, wording } } }';
        this.props.onPostResult('deal-loss', showEntity(this.props.authFetch, 'deal', graphQL));
        this.close();
      } else {
        this.props.openToast(false, 'Certains champs obligatoires sont vides');
      }
    }
  }

  close() {
    this.reset();
    if (this.props.onClose) {
      this.props.onClose();
    }
  }
}

export default withAuth(ModalDealLost);
